<template>
  <v-hover v-slot="{ isHovering, props: hoverProps }">
    <v-list-item
      v-bind="hoverProps"
      density="comfortable"
      class="hover-list-item px-4 py-2"
      rounded="0"
      @click="$emit('click')"
    >
      <template #title>
        <span class="hover-list-item__title" :class="{ 'hover-list-item__title--error': isHovering }">{{ text }}</span>
      </template>
      <template #append>
        <v-icon
          :icon="icon"
          size="22"
          :color="isHovering ? color : undefined"
          :class="{ 'text-medium-emphasis': !isHovering }"
        />
      </template>
    </v-list-item>
  </v-hover>
</template>

<script>
export default {
  name: "HoverListItem",
  props: {
    color: {
      default: "primary",
      type: String,
    },
    text: {
      default: 'Unused "text" prop',
      type: String,
    },
    icon: {
      default: "mdi-alert",
      type: String,
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
.hover-list-item {
  min-height: 48px;
}

.hover-list-item__title--error {
  color: rgb(var(--v-theme-error));
}
</style>
